import { render, staticRenderFns } from "./CalculatorPriceComponent.vue?vue&type=template&id=5307ec28&"
import script from "./CalculatorPriceComponent.vue?vue&type=script&lang=ts&"
export * from "./CalculatorPriceComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports